(function () {
    'use strict';

    angular.module("EventListApp").directive('backToTop', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                $(window).scroll(function () {
                    if ($(window).scrollTop() >= 250) {
                        element.fadeIn(200);
                    }
                    else {
                        element.fadeOut(200);
                    }
                });
                element.on('click', function () {
                    $('body,html').animate({
                        scrollTop: 0                       // Scroll to top of body
                    }, 500);
                });
            }
        }
    });



})();